// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13dOc","colMin":"styles_colMin__a9uIj"};